import React from "react";
import {
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from "@mui/material";

import type { FormFieldSize } from "../../types";

export type SwitchColor = Exclude<
  MuiSwitchProps["color"],
  "primary" | "secondary"
>;

export interface SwitchProps extends Omit<
  MuiSwitchProps,
  | "size"
  | "sx"
  | "style"
  | "icon"
  | "checkedIcon"
  | "slots"
  | "slotProps"
  | "classes"
> {
  /** Switch size. Default: 'md' */
  size?: FormFieldSize;
  /** Checked color. Default: 'brandPrimary' */
  color?: SwitchColor;
  /** Root test id. Default: 'ds-switch' */
  "data-testid"?: string;
}

const sizeMap: Record<FormFieldSize, MuiSwitchProps["size"]> = {
  sm: "small",
  md: "medium",
};

export const Switch = React.forwardRef<
  React.ComponentRef<typeof MuiSwitch>,
  SwitchProps
>(
  (
    {
      size = "md",
      color = "brandPrimary",
      "data-testid": dataTestId = "ds-switch",
      ...rest
    },
    ref,
  ) => {
    const rootSlotProps = { "data-testid": dataTestId };
    return (
      <MuiSwitch
        ref={ref}
        size={sizeMap[size]}
        color={color}
        slotProps={{ root: rootSlotProps }}
        {...rest}
      />
    );
  },
);

Switch.displayName = "Switch";
